import React, { useEffect, useRef, useState, useContext } from "react";

import { useParams } from 'react-router-dom';

import Header from "../Header";
import Footer from "../Footer";
import Preview from "../Preview";
// import PublishButton from "../PublishButton";
import ActivitySettings from "../ActivitySettings";
import ActivitySelection from "../ActivitySelection";
import Colors from "../Colors";
import Logo from "../Logo";
import MarketingAutomation from "../MarketingAutomation";
import UITexts from "../UITexts";
import Avatars from "../Avatars";
import InAppNotifications from "../NotificationsInApp";
import Rewards from "../Rewards";
import ModuleImage from "../ModuleImage";
import Premium from "../Premium";

import { ReactComponent as Eye } from '../../assets/eye_white.svg';
import { ReactComponent as Check } from '../../assets/check_grey.svg';
import { ReactComponent as Qrcode } from '../../assets/qrcode_small.svg';
import { ReactComponent as Add } from '../../assets/add_black.svg';
import { ReactComponent as Cancel } from '../../assets/cancel.svg';
import { ReactComponent as EditPurple } from '../../assets/edit_purple.svg';
import { ReactComponent as QrcodePurple } from '../../assets/qrcode_purple.svg';
import { ReactComponent as Remove } from '../../assets/remove.svg';
import { ReactComponent as EditSvg } from '../../assets/edit.svg';
import { ReactComponent as PictureSvg } from '../../assets/picture.svg';


import { ReactComponent as UnpublishSvg } from '../../assets/unpublish.svg';

import poll from '../../assets/poll_big.png';
import questions from '../../assets/questions_big.png';
import video from '../../assets/video_big.png';
import download from '../../assets/download_big.png';
import profile from '../../assets/profile_big.png';
import AR from '../../assets/AR_big.png';
import photobooth from '../../assets/photobooth_big.png';
import matchgame from '../../assets/matchgame_big.png';
import QRCodeModal from "../QR";
import QRCodeModalAnalytics from "../QRAnalytics";


import questions_small from '../../assets/questions_small.png';
import video_small from '../../assets/video_small.png';
import download_small from '../../assets/download_small.png';
import profile_small from '../../assets/profile_small.png';

import { AuthContext } from '../../context/AuthContext';
import { useForm } from "react-hook-form";

import { db, storage } from "../../firebase";
import { ref, getDownloadURL, uploadBytesResumable, deleteObject, uploadString } from "firebase/storage";
import { doc, getDocs, getDoc, collection, onSnapshot, setDoc, updateDoc, addDoc, query, where } from "firebase/firestore";

import Resizer from "react-image-file-resizer";

export default function Edit({ type }) {

    const [message, changeMessage] = useState('');
    const setMessage = (text) => {
        changeMessage(text)
        setTimeout(() => {
            changeMessage();
        }, 3000);
    };

    const [activity, setActivity] = useState(false);
    const [activeActivityIndex, setActivityIndex] = useState(false);
    const changeActivity = (event) => {

        setNewActivity(false);

        let activeModuleIndex = event.currentTarget.dataset.moduleindex;
        let activeActivityIndex = event.currentTarget.dataset.activityindex;
        setModuleIndex(activeModuleIndex);
        setActivityIndex(activeActivityIndex);

        setActivity(project['PACKETS'][activeModuleIndex]['activities'][activeActivityIndex]);
        setSettingsType(project['PACKETS'][activeModuleIndex]['activities'][activeActivityIndex]['link']);

        setActiveSection("activitySettings");
    }

    const [newActivity, setNewActivity] = useState(false);
    const [activeModuleIndex, setModuleIndex] = useState(false);
    const [isShowActivitySelection, setShowActivitySelection] = useState(false);
    const showActivitySelection = (event) => {

        setShowColors(false);
        setNewActivity(true);

        let moduleindex = event.target.dataset.moduleindex;
        setModuleIndex(moduleindex);
        setActivity(false);
        let activityindex = 0;
        if (project['PACKETS'][moduleindex]['activities'])
            activityindex = project['PACKETS'][moduleindex]['activities'].length;

        //console.log('activityindex='+activityindex);

        setActivityIndex(activityindex);

        setActiveSection('activity');
    };

    const [settingsType, setSettingsType] = useState(false);

    const premiumActivities = process.env.REACT_APP_PREMIUM_ACTIVITIES;
    const [showPremium, setShowPremium] = useState(false);
    const showActivitySettings = (type) => {

        if (
            user.account != 'premium' &&
            premiumActivities.includes(type)
        ){

            setShowPremium(true);

        } else {

            setSettingsType(type);

            setActiveSection('activitySettings');

            setShowActivitySelection(false);

        }
    };

    const close = () => {

        setActiveSection(false);
    }

    const {
        register,
        reset,
        handleSubmit,
        formState: { errors },
    } = useForm({

    });

    const { currentUser, user } = useContext(AuthContext);

    const removeFile = async (fileUrl) => {

        if (fileUrl !== '') {
            const storageRef = ref(storage, fileUrl);

            if (storageRef) {
                deleteObject(storageRef).then(() => {
                    console.log('File deleted successfully');
                }).catch((error) => {
                    console.log('Uh-oh, an error occurred!');
                });
            }
        }

    }

    // make url friendly from string
    function slug(value) {
        return value == undefined ? '' : value.replace(/[^a-z0-9_]+/gi, '-').replace(/^-|-$/g, '').toLowerCase();
    }

    const [newProject, setNewProject] = useState(false);
    const save = async (data, test_on_device = false) => {

        /*
        //==========================
        // Copy an existing project
        console.log('Start copying project');        
        let snap = await getDoc(doc(db, "projects", 'SgCPsZwjdpY0GhJ71hJf'));        
        const ref = addDoc(collection(db, "projects"), snap.data()
fetchxmlhttpfactory.js:270 Загрузка Fetch завершена: POST (https://firestore.googleapis.com/google.firestore.v1.Firestore/Listen/chann…wnV).then((docRef) => {
            console.log('Successfully copied');
        });
        //==========================
        */
        //console.log(data);
        if (data['status'])
            project['status'] = data['status'];

        if (data['name'])
            project['name'] = data['name'];

        if (data['PACKETS']) {
            for (var key in project['PACKETS']) {
                project['PACKETS'][key]['name'] = data['PACKETS'][key]['name'];
            }
        }

        if (!projectID) { //create new

            if (!newProject) {

                setNewProject(true);

                const timestamp = Date.now(); // This would be the timestamp you want to format

                project['user'] = currentUser;
                project['status'] = 'publish';
                project['creation_date'] = timestamp;

                setProject(project);

                console.log(project);

                //const ref = addDoc(collection(db, "projects"), project)

                //db.collection("projects").doc("qwer_1").set({project})


                // make url friendly from name
                let code = slug(project['name']);
                let flag = true;
                while (flag) {

                    let snap = await getDoc(doc(db, "projects", code))
                    let project = snap.data();

                    if (project) {

                        var matches = code.match(/\d+$/);
                        //console.log(matches);

                        let number = 0;

                        if (matches !== null) {
                            number = parseInt(matches[0]);
                            number++;
                        }

                        code = code.replace(/\d+$/, '');
                        code += number;

                    } else {

                        flag = false;
                    }
                }

                console.log('code=' + code);
                console.log(project);

                downloadActivityIcons(project, code);
                downloadRewardIcon(project, code);
                downloadModuleIcon(project, code);

                const ref = setDoc(doc(db, "projects", code), project)

                    .then((docRef) => {

                        window.history.replaceState(null, "Lagoon " + project['name'], "/edit/" + code)

                        setProjectId(code);

                        if (test_on_device)
                            testOnDevice(code);
                    });

            }

        } else {

            setProject(project);

            //console.log(project);

            updateProjectFirebase(projectID);
            downloadLogo(projectID);

            downloadActivityIcons(project, projectID);
            downloadRewardIcon(project, projectID);
            downloadModuleIcon(project, projectID);

            if (test_on_device)
                testOnDevice(projectID);
        }
    }

    const testOnDevice = (projectId) => {
        window.open(site + '' + projectId + '/', '_blank');
    }

    const updateProjectFirebase = async (projectID) => {

        console.log(projectID);
        console.log(project);

        let temp = project;
        if(temp['analytics'])
            delete temp['analytics'];

        const ref = await doc(db, "projects", projectID);
        await updateDoc(ref, temp);
    }

    const resizeFile = (file) =>
        new Promise((resolve) => {

            const extension = file.name.split('.').pop();
            Resizer.imageFileResizer(
                file,
                120,
                20,
                "PNG",
                80,
                0,
                (uri) => {
                    resolve(uri);
                },
                "base64"
            );
        });


    const LoadModuleIconFirebase = async (file, project, projectID, packet_i, type) => {

        let new_name = projectID + '_' + packet_i + '_' + type;

        const extension = file.name.split('.').pop();
        const storageRef = ref(storage, `/modules/${new_name}.${extension}`);
        const uploadTask = uploadBytesResumable(storageRef, file);

        uploadTask.on("state_changed",
            (snapshot) => {

            },
            (error) => {

                setMessage("Can't upload file. " + error);

            },
            () => {

                getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {

                    console.log('#2');
                    console.log('downloadURL=' + downloadURL);
                    console.log(type);

                    project['PACKETS'][packet_i]['image'][type] = downloadURL;
                    setProject(project);
                    updateProjectFirebase(projectID);

                    console.log(project);

                });
            }
        );
    }

    const downloadModuleIcon = async (project, projectID) => {

        //console.log('=====1');
        //console.log(project);

        for (var packet_i in project['PACKETS']) {

            if (!!project['PACKETS'][packet_i]['temp_image']) {

                if (!project['PACKETS'][packet_i]['image'])
                    project['PACKETS'][packet_i]['image'] = {};

                for (var type in project['PACKETS'][packet_i]['temp_image']) {

                    let file = project['PACKETS'][packet_i]['temp_image'][type];

                    console.log(file);

                    if (file instanceof File) {

                        console.log('#1');
                        console.log(type);

                        LoadModuleIconFirebase(file, project, projectID, packet_i, type);


                    } else {

                        project['PACKETS'][packet_i]['image'][type] = file;

                    }
                }
            }

            if (project['PACKETS'][packet_i]['image'])
                delete project['PACKETS'][packet_i]['temp_image'];
        }

        setProject(project);
        updateProjectFirebase(projectID);

        console.log(project);


    }

    const LoadRewardIconFirebase = async (file, project, projectID, index) => {

        let new_name = projectID + '_' + index;

        const extension = file.name.split('.').pop();
        const storageRef = ref(storage, `/rewards/${new_name}.${extension}`);
        const uploadTask = uploadBytesResumable(storageRef, file);

        uploadTask.on("state_changed",
            (snapshot) => {

            },
            (error) => {

                setMessage("Can't upload file. " + error);

            },
            () => {

                getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {

                    console.log('#2');
                    console.log('downloadURL=' + downloadURL);
                    console.log(type);

                    project['rewards'][index]['image'] = downloadURL;
                    setProject(project);
                    updateProjectFirebase(projectID);

                    console.log(project);

                });
            }
        );
    }

    const downloadRewardIcon = async (project, projectID) => {

        for (var index in project['rewards']) {

            if (!!project['rewards'][index]['temp_image']) {

                if (!project['rewards'][index]['image'])
                    project['rewards'][index]['image'] = {};

                let file = project['rewards'][index]['temp_image'];

                console.log(file);

                if (file instanceof File) {

                    console.log('#1');

                    LoadRewardIconFirebase(file, project, projectID, index);


                } else {

                    project['rewards'][index]['image'] = file;

                }

            }

            if (project['rewards'][index]['image'])
                delete project['rewards'][index]['temp_image'];
        }

        setProject(project);
        updateProjectFirebase(projectID);
        //===============


        if (project['reward'] && project['reward']['temp_icon'] != '') {

            let file = project['reward']['temp_icon'];
            let new_name = projectID;

            const extension = file.name.split('.').pop();
            const storageRef = ref(storage, `rewards/${new_name}.${extension}`);
            const uploadTask = uploadBytesResumable(storageRef, file);


            console.log(extension);

            uploadTask.on("state_changed",
                (snapshot) => {

                },
                (error) => {

                    setMessage("Can't upload file. " + error);

                },
                () => {

                    getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {

                        console.log('downloadURL=' + downloadURL);
                        project['reward']['icon'] = downloadURL;
                        setProject(project);
                        updateProjectFirebase(projectID);
                    });
                }
            );

        }
        if (project['reward'])
            delete project['reward']['temp_icon'];

    }

    const LoadActivityImageFirebase = async (file, new_name, project, packet_i, i, reward = false) => {

        console.log('-------');
        console.log(file);
        console.log(new_name);

        const extension = file.name.split('.').pop();
        const storageRef = ref(storage, `activities/${new_name}.${extension}`);
        const uploadTask = uploadBytesResumable(storageRef, file);


        console.log('-------1');
        console.log(`activities/${new_name}.${extension}`);

        uploadTask.on("state_changed",
            (snapshot) => {

            },
            (error) => {

                console.log('-------2');

                setMessage("Can't upload file. " + error);
                return;

            },
            () => {

                console.log('-------3');

                getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {

                    console.log('-------4');

                    console.log(downloadURL);

                    delete project['PACKETS'][packet_i]['activities'][i]['temp_icon'];
                    delete project['PACKETS'][packet_i]['activities'][i]['temp_reward_icon'];

                    if (reward) {

                        console.log('reward');

                        if (!project['PACKETS'][packet_i]['activities'][i]['reward'])
                            project['PACKETS'][packet_i]['activities'][i]['reward'] = [];
                        project['PACKETS'][packet_i]['activities'][i]['reward']['image'] = downloadURL;

                        console.log(project);

                    } else {
                        project['PACKETS'][packet_i]['activities'][i]['icon'] = downloadURL;
                    }

                    console.log(project);

                    setProject(project);
                    updateProjectFirebase(projectID);

                });
            }
        );

    }

    const downloadActivityIcons = async (project, projectID) => {

        //console.log('=====1');
        //console.log(project);

        for (var packet_i in project['PACKETS']) {
            for (var i in project['PACKETS'][packet_i]['activities']) {

                if (!!project['PACKETS'][packet_i]['activities'][i]['temp_icon']) {

                    console.log('========= activity icon');
                    console.log(project);

                    LoadActivityImageFirebase(project['PACKETS'][packet_i]['activities'][i]['temp_icon'], projectID + '_' + packet_i + '_' + i, project, packet_i, i);

                }

                if (!!project['PACKETS'][packet_i]['activities'][i]['temp_reward_icon']) {

                    console.log('========= reward icon');

                    LoadActivityImageFirebase(project['PACKETS'][packet_i]['activities'][i]['temp_reward_icon'], projectID + '_' + packet_i + '_' + i + '_reward', project, packet_i, i, true);

                }


            }
        }
    }

    const downloadLogo = async (projectID) => {
        if (newLogo) {

            var file = newLogo;

            console.log(file)

            const extension = file.name.split('.').pop();

            if (extension == 'svg') {

                const storageRef = ref(storage, `logo/${projectID}.svg`);

                const uploadTask = uploadBytesResumable(storageRef, file);

                uploadTask.on("state_changed",
                    (snapshot) => {

                    },
                    (error) => {

                        setMessage("Can't upload file. " + error);
                        return;

                    },
                    () => {

                        getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {

                            if (project['logo'] != downloadURL) {
                                //removeFile(project['logo']);
                                project['logo'] = downloadURL;
                                setProject(project);
                                updateProjectFirebase(projectID);
                            }

                        });
                    }
                );

            } else {

                file = await resizeFile(file);

                const storageRef = ref(storage, `logo/${projectID}.png`);

                const uploadTask = await uploadString(storageRef, file, "data_url");
                const thumbUrl = await getDownloadURL(uploadTask.ref);

                if (project['logo'] != thumbUrl) {
                    //removeFile(project['logo']);
                    project['logo'] = thumbUrl;
                    setProject(project);
                    updateProjectFirebase(projectID);
                }
            }
        }
        else if (removeLogo) {

            removeFile(project['logo']);
            project['logo'] = '';
            setProject(project);
            updateProjectFirebase(projectID);

        }


    }

    const saveButton = async (data) => {

        save(data);
        setMessage('Successfully modified');

    }

    const addModule = async (data) => {

        let temp = { ...project };
        temp['PACKETS'] = [...temp['PACKETS'], { name: '' }];
        //console.log(temp);
        setProject(temp);
    }

    const [project, setProject] = useState({
        name: '',
        PACKETS: [
            {
                name: '',
                activities: [],
            }
        ],
        COLORS: [
            { name: 'Loader background', color: '#1a2076' },
            { name: 'Background', color: '#3c0d5b' },
            { name: 'Footer menu background', color: '#171032' },
            { name: 'Rewards and wallet background', color: '#0d0b1d' },
            { name: 'Rewards header background', color: '#510b77' },
            { name: 'Leaderboard background', color: '#882aff' },
            { name: 'Greeting text color', color: '#b63fff' },
            { name: 'Activity background', color: '#541D94' },
            { name: 'Activity text color', color: '#ffffff' },
            { name: 'Buttons background', color: '#b63fff' },
            { name: 'Buttons color', color: '#ffffff' },
            { name: 'Module names', color: '#ffffff' },
            { name: 'Quiz responses gradient color one', color: '#e337ff' },
            { name: 'Quiz responses gradient color two', color: '#882aff' },
            { name: 'Quiz responses text color', color: '#ffffff' },
            { name: 'NFT color 1', color: '#3bb17e' },
            { name: 'NFT color 2', color: '#d9291d' },
            { name: 'NFT color 3', color: '#317ee3' },
        ],
        logo: '',
        texts: false,

    });

    const removeActivity = () => {

        if (activeActivityIndex !== false)
            project['PACKETS'][activeModuleIndex]['activities'][activeActivityIndex] = false;

    }

    const addActivity = (activity) => {

        console.log(activity);


        //==========

        let temp = { ...project };

        if (!temp['PACKETS'][activeModuleIndex]['activities'])
            temp['PACKETS'][activeModuleIndex]['activities'] = [];

        if (newActivity)
            temp['PACKETS'][activeModuleIndex]['activities'] = [...temp['PACKETS'][activeModuleIndex]['activities'], activity];

        setProject(temp);
    }

    const [projectID, setProjectId] = useState(false);

    const params = useParams();

    const setPageProps = async () => {

        if (!!params.id) {

            let projectID = params.id;

            if (projectID) {
                let snap = await getDoc(doc(db, "projects", projectID));
                let project = snap.data();
                if (!(project['logo']))
                    project['logo'] = '';

                if (!(project['texts']))
                    project['texts'] = false;

                setProject(project);

                console.log('project');
                console.log(project);

                setProjectId(projectID);
                setLogo(project["logo"]);
            }

        }

        //<Page404 text="Project not found" />
    };


    useEffect(() => {

        setPageProps();

    }, []);

    if (type == 'create')
        var pageName = 'Create event';
    else
        var pageName = 'Edit event';

    const [status, setStatus] = useState('draft');
    const [publishMessage, changePublishMessage] = useState('');
    const [unpublishMessage, changeUnpublishMessage] = useState('');
    const setPublishMessage = (text) => {
        changePublishMessage(text)
        setTimeout(() => {
            changePublishMessage();
        }, 5000);
    };
    const setUnpublishMessage = (text) => {
        changeUnpublishMessage(text)
        setTimeout(() => {
            changeUnpublishMessage();
        }, 5000);
    };
    const site = process.env.REACT_APP_DEMO_SITE;
    const testButton = async (data) => {
        setStatus('publish');
        data['status'] = 'publish';
        save(data, true);
        //window.location.replace(site+'#/project/'+projectID);
    }
    const publishButton = async (data) => {
        setStatus('publish');
        data['status'] = 'publish';
        save(data);
        setPublishMessage('Successfully publish');
    }
    const unpublishButton = async (data) => {
        setStatus('draft');
        data['status'] = 'draft';
        save(data);
        setPublishMessage('Successfully unpublish');
    }

    const [activeSection, setActiveSection] = useState(false);

    /* logo */

    const [logo, setLogo] = useState(false);
    const [newLogo, setNewLogo] = useState(false);
    const [removeLogo, setRemoveLogo] = useState(false);
    const saveLogo = (file) => {

        //console.log(file);        
        setSelectedFile(file);
        setNewLogo(file);

        if (file)
            setRemoveLogo(false);
        else
            setRemoveLogo(true);

    }
    const showLogo = (event) => {

        setActiveSection("logo");

    };
    const hideLogo = (event) => {

        setActiveSection(false);
    }

    // preview logo

    const [selectedFile, setSelectedFile] = useState();
    useEffect(() => {
        if (!selectedFile) {
            setLogo(undefined)
            return
        }

        const objectUrl = URL.createObjectURL(selectedFile)
        setLogo(objectUrl)
        return () => URL.revokeObjectURL(objectUrl)
    }, [selectedFile])

    /* color */

    const [isShowColors, setShowColors] = useState(false);
    const [picker, setPicker] = useState(false);
    const showColors = (event) => {

        setActiveSection("colors");
    };
    const hideColors = (event) => {

        setActiveSection(false);
    }


    const saveColor = (colorindex, color) => {
        let temp = { ...project };
        temp['COLORS'][colorindex]['color'] = color;
        setProject(temp);
    }
    const hidePicker = (event) => {
        let elements = document.querySelectorAll(".color");
        var outside = true;
        elements.forEach(element => {
            if (element.contains(event.target)) {
                outside = false;
            }
        });
        if (outside)
            setPicker(false);
    }

    /*** QR CODE ***/
    const [isQRCode, setShowQRCode] = useState(false);

    const [savedQR, setSavedQR] = useState(null);
    const savedQRRef = useRef(null);

    useEffect(() => {
        if (savedQR) {
            // clear old QR code
            savedQRRef.current.innerHTML = '';

            savedQR.append(savedQRRef.current);
        }
    }, [savedQR]);

    const showQRCode = () => {
        setShowQRCode(true);
        document.body.classList.add('fixed');
    }

    const [QRPacketIndex, setQRPacketIndex] = useState(false);
    const [QRActivityIndex, setQRActivityIndex] = useState(false);

    const [QRLink, setQRLink] = useState(site + '#/project/' + projectID);
    const [QRCode, setQRCode] = useState(false);
    const [QRName, setQRName] = useState(false);

    const [QRCodePropertiesDefault, setQRCodePropertiesDefault] = useState(false);

    const showPacketQr = (packetIndex, projectID) => {

        console.log('showPacketQr');

        setQRPacketIndex(packetIndex);
        setQRActivityIndex(false);

        console.log(1);

        setQRCode(project["PACKETS"][packetIndex]['QRCode']);

        console.log(2);

        setQRCodePropertiesDefault(project["PACKETS"][packetIndex]['QRCode'] ? project["PACKETS"][packetIndex]['QRCode'] : project['QRCode'] ? project['QRCode'] : false);

        console.log(3);

        setQRName(project ? project['name'] + ' ' + project["PACKETS"][packetIndex]['name'] : '');



        //console.log(packetIndex);
        //console.log(projectID);

        console.log(1);

        setQRLink(site + projectID + '/?unlock=packet_' + packetIndex);


        console.log(1);

        setShowQRCode(true);
        document.body.classList.add('fixed');
    }

    const showActivityQr = (packet, packetIndex, activityIndex) => {

        console.log('showActivityQr');

        setQRPacketIndex(packetIndex);
        setQRActivityIndex(activityIndex);

        console.log('activityIndex='+activityIndex);

        setQRCode(project["PACKETS"][packetIndex]['activities'][activityIndex]['QRCode']);
        setQRCodePropertiesDefault(project["PACKETS"][packetIndex]['activities'][activityIndex]['QRCode'] ? project["PACKETS"][packetIndex]['activities'][activityIndex]['QRCode'] : project['QRCode'] ? project['QRCode'] : false);

        setQRName(project ? project['name'] + ' ' + project["PACKETS"][packetIndex]['name'] + ' ' + project["PACKETS"][packetIndex]['activities'][activityIndex]['name'] : '');

        //console.log(packet);

        setQRLink(site + '#/' + packet?.activities[0].packet_id + packet?.activities[0].link);

        //console.log('link');
        //console.log(site + '#/' + packet?.activities[0].packet_id + packet?.activities[0].link);

        setShowQRCode(true);
        document.body.classList.add('fixed');
    }

    //===============================
    // QR code Analytics

    const saveQRCodeAnalytics = async (QRCode) => {

        if (QRActivityIndex !== false) { //activity

            console.log('activity');
            console.log(projectID+'_'+QRPacketIndex+'_'+QRActivityIndex);

            QRCode.svg = await saveQRCodeSvg(QRCode.svg, projectID+'_'+QRPacketIndex+'_'+QRActivityIndex);

            project["PACKETS"][QRPacketIndex]['activities'][QRActivityIndex].QRCode = QRCode;
            setProject(Object.assign(project));

            if (QRCode && QRCode.svg && projectID) {

                const project_ref = await doc(db, "projects", projectID);
                await updateDoc(project_ref, {
                    PACKETS: project["PACKETS"],
                });
            }

        } else { //module

            console.log('module');
            console.log(projectID+'_'+QRPacketIndex);

            QRCode.svg = await saveQRCodeSvg(QRCode.svg, projectID+'_'+QRPacketIndex);

            project["PACKETS"][QRPacketIndex].QRCode = QRCode;
            setProject(Object.assign(project));

            if (QRCode && QRCode.svg && projectID) {

                const project_ref = await doc(db, "projects", projectID);
                await updateDoc(project_ref, {
                    PACKETS: project["PACKETS"],
                });
            }
        }

    }
    const saveQRCodeSvg = async (svg, projectID) => {

        const storageRef = ref(storage, `qrcode/${projectID}.svg`);
        const metadata = {contentType: "image/svg+xml"};

        var svg = new Blob([svg], {
            type: 'image/svg+xml'
        });

        await uploadBytesResumable(storageRef, svg);//, metadata

        return await getDownloadURL(storageRef);

    }

    const hideQRCode = () => {
        setShowQRCode(false);
        document.body.classList.remove('fixed');
    }

    useEffect(() => {

        setQRLink(site + projectID);
        // setQRLink(site + '#/project/' + projectID);
    }, [projectID]);


    /* Marketing Automation */

    const [isShowMarketingAutomation, setShowMarketingAutomation] = useState(false);
    const showMarketingAutomation = (event) => {

        setActiveSection('marketingAutomation');

    }
    const saveMarketingAutomation = (texts) => {

        console.log(texts);
        project['texts'] = texts;
        setProject(project);

        console.log(project);
    }
    const hideMarketingAutomation = (event) => {
        setShowMarketingAutomation(false);
    }

    /* Texts */

    const [isShowUITexts, setShowUITexts] = useState(false);
    const showUITexts = (event) => {

        setActiveSection('UITexts');

    }
    const saveUITexts = (texts) => {

        console.log(texts);
        project['ui_texts'] = texts;
        setProject(project);

        console.log(project);
    }
    const hideUITexts = (event) => {
        setShowUITexts(false);
    }


    /* Avatars */

    const [isShowAvatars, setShowAvatars] = useState(false);
    const showAvatars = (event) => {

        setActiveSection('Avatars');

    }
    const saveAvatars = (avatars) => {

        console.log(avatars);
        project['avatars'] = avatars;
        setProject(project);

        console.log(project);
    }
    const hideAvatars = (event) => {
        setShowAvatars(false);
    }


    /* Notifications in APP */

    const [isShowInAppNotifications, setShowInAppNotifications] = useState(false);
    const showInAppNotifications = () => {
        setActiveSection('InAppNotifications');
    }

    const saveInAppNotifications = (inAppNotifications) => {
        console.log(inAppNotifications);
        project['inAppNotifications'] = inAppNotifications;
        setProject(project);
        console.log(project);
    }

    const hideInAppNotifications = () => {
        setShowInAppNotifications(false);
    }

    /* Rewards */

    const [isShowReward, setShowReward] = useState(false);
    const showReward = (event) => {

        console.log(project);

        setActiveSection("rewards");
    }
    const saveRewards = (rewards) => {

        console.log(rewards);
        project['rewards'] = rewards;
        setProject(project);
        console.log(project);
    }
    const hideRewards = (event) => {

        setActiveSection(false);
    }

    /* Module image */

    const [moduleImageIndex, setModuleImageIndex] = useState(false);
    const [moduleImage, setModuleImage] = useState(false);
    const [isShowModuleImage, setShowModuleImage] = useState(false);
    const showModuleImage = (moduleIndex) => {

        setModuleImageIndex(moduleIndex);

        setModuleImage(project["PACKETS"][moduleIndex]['image']);

        setActiveSection("moduleImage");
    }
    const saveModuleImage = (image, moduleIndex) => {

        console.log(image);
        console.log(moduleIndex);

        project["PACKETS"][moduleIndex]['temp_image'] = image;
        setProject(project);

    }
    const hideModuleImage = (event) => {

        setActiveSection(false);
    }
    //========================================
    // check rights ("free" or "premium")

    const [projects, setProjects] = useState(false);
    const getProjects = async (o) => {

        const ref = collection(db, "projects");
        const q = query(ref, where('user', '==', currentUser));
        const snapshot = await getDocs(q);
        const projects = snapshot.docs.map((doc) => ({ ...doc.data(), id: doc.id }));
        setProjects(projects);
    }

    useEffect(() => {
        if (type == 'create_project' && !projects)
            getProjects();
    }, []);

    return (

        <div className="page page_project page_edit" onClick={hidePicker}>

            <Header />

            <main>


                {(type != 'create_project' || (projects && user && (user.account == 'premium' || projects.length < 1 ))) ?

                    <>
                        {project['name'] != '' || type == 'create_project' ?

                            <div className="content">

                                <ul className="breadcrumbs">
                                    <li>
                                        <a href="/">Home</a>
                                    </li>
                                    <li>
                                        <a href="/">Events</a>
                                    </li>
                                    <li>
                                        <span>
                                            {pageName}
                                        </span>
                                    </li>
                                </ul>

                                <div className="page__title">
                                    <h1>{pageName}</h1>
                                    <div className="title__buttons">

                                        <div className="buttons_publish_unpublish">

                                            {project.status == 'publish'
                                                ?
                                                <button className="button_publish button" onClick={handleSubmit(testButton)}>
                                                    <Eye />
                                                    Test on device
                                                </button>
                                                :
                                                null
                                            }

                                        </div>

                                        <div className="button_border test" onClick={handleSubmit(publishButton)}>
                                            <Check />
                                            Publish
                                        </div>
                                        <div className="error">{publishMessage}</div>

                                    </div>
                                </div>

                                <div className="row">

                                    <section className="section_event">

                                        {isQRCode && (
                                                user.account == 'premium' ?
                                                <QRCodeModalAnalytics
                                                    hideQRCodeAnalytics={hideQRCode}
                                                    QRCodeDefault={QRCode}
                                                    name={QRName}
                                                    defaultLink={QRLink}
                                                    saveQRCodeAnalytics={saveQRCodeAnalytics}
                                                    QRCodePropertiesDefault={QRCodePropertiesDefault}
                                                />
                                                :
                                                <QRCodeModal
                                                    hideQRCode={hideQRCode}
                                                    defaultLink={QRLink}
                                                    onSave={setSavedQR}
                                                />
                                        )}

                                        <form className="left">
                                            <label>Enter project name</label>
                                            <input
                                                {...register("name", { required: "Name is required" })}
                                                placeholder="Name event"
                                                defaultValue={project['name']}
                                            />
                                            <div className="error">{errors.name?.message}</div>

                                            <div className={
                                                activeSection == "logo" ?

                                                    "button_colors button_light active"

                                                    :

                                                    "button_colors button_light"

                                            } onClick={showLogo}>Change project logo</div>

                                            <div className={
                                                activeSection == "colors" ?

                                                    "button_colors button_light active"

                                                    :

                                                    "button_colors button_light"

                                            } onClick={showColors}>Change project colors</div>

                                            <div className={
                                                activeSection == "marketingAutomation" ?

                                                    "button_colors button_light active"

                                                    :

                                                    "button_colors button_light"

                                            } onClick={showMarketingAutomation}>Marketing automation</div>

                                            <div className={
                                                activeSection == "rewards" ?

                                                    "button_colors button_light active"

                                                    :

                                                    "button_colors button_light"

                                            } onClick={showReward}>Rewards</div>

                                            <div className={
                                                activeSection == "UITexts" ?

                                                    "button_colors button_light active"

                                                    :

                                                    "button_colors button_light"

                                            } onClick={showUITexts}>UI texts</div>

                                            <div className={
                                                activeSection === "InAppNotifications" ?

                                                    "button_colors button_light active"

                                                    :

                                                    "button_colors button_light"

                                            } onClick={showInAppNotifications}>In-App Notifications</div>


                                            <div className={
                                                activeSection == "Avatars" ?

                                                    "button_colors button_light active"

                                                    :

                                                    "button_colors button_light"

                                            } onClick={showAvatars}>Avatars</div>




                                            {!!project["PACKETS"] &&

                                                project["PACKETS"].map((module, moduleIndex) =>

                                                    <div className="module" key={moduleIndex}>
                                                        <div className="title">

                                                            <input
                                                                {...register("PACKETS[" + moduleIndex + "][name]", { required: "Module " + (moduleIndex + 1) + " name is required" })}
                                                                placeholder="Name event"
                                                                defaultValue={module.name}
                                                            />

                                                            <div>
                                                                {/*<div className="edit"><EditSvg /></div>*/}

                                                                <div className={
                                                                    activeSection == "moduleImage" && moduleImageIndex == moduleIndex ?
                                                                        "image active"
                                                                        :
                                                                        "image"
                                                                } onClick={() => showModuleImage(moduleIndex)}>
                                                                    <PictureSvg />
                                                                </div>

                                                                <div className="qrcode" onClick={() => showPacketQr(moduleIndex, projectID)}>
                                                                    <Qrcode />
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="error">{errors["PACKETS"] ? errors["PACKETS"][moduleIndex] ? errors["PACKETS"][moduleIndex]["name"]?.message : '' : ''}</div>

                                                        {/* ==== */}

                                                        {!!module['activities'] && module['activities'].length > 0 &&

                                                            <div className="bg_light">

                                                                {module['activities'].map((activityItem, activityIndex) =>

                                                                    activityItem ?

                                                                        <div className="activity {activityItem.active ? 'active' :  null}" key={activityIndex}>
                                                                            <div className="icon">
                                                                                {
                                                                                    {
                                                                                        '/quiz': <img src={questions} alt="" />,
                                                                                        '/poll': <img src={poll} alt="" />,
                                                                                        '/video': <img src={video} alt="" />,
                                                                                        '/download': <img src={download} alt="" />,
                                                                                        '/profile': <img src={profile} alt="" />,
                                                                                        '/ar': <img src={AR} alt="" />,
                                                                                        '/photobooth': <img src={photobooth} alt="" />,
                                                                                        '/profile': <img src={profile} alt="" />,
                                                                                        '/matchgame': <img src={matchgame} alt="" />

                                                                                    }[activityItem.link]
                                                                                }
                                                                            </div>
                                                                            <div className="name">
                                                                                {activityItem.name}
                                                                                <div className="icon edit" onClick={changeActivity} data-activityindex={activityIndex} data-moduleindex={moduleIndex}><EditPurple /></div>
                                                                            </div>
                                                                            <div className="icon qrcode" onClick={() => showActivityQr(module, moduleIndex, activityIndex)}><QrcodePurple /></div>
                                                                            <div className="move"></div>
                                                                        </div>
                                                                        :
                                                                        null

                                                                )
                                                                }

                                                            </div>

                                                        }

                                                        {/* ==== */}

                                                        <div className="bg_light">
                                                            <div className="button button_add" onClick={showActivitySelection} data-moduleindex={moduleIndex} data-activityindex={false} >Add new activity</div>
                                                        </div>
                                                    </div>
                                                )

                                            }

                                            <div className="button_light add_module"
                                                onClick={addModule}
                                            >
                                                <Add />
                                                Add new module
                                            </div>
                                            <input type="hidden" defaultValue="draft"
                                                {...register("status")}
                                            />

                                            <div className="save">
                                                <button className="button check"
                                                    onClick={handleSubmit(saveButton)}>Save</button>

                                                <div className="error">{message}</div>
                                            </div>


                                        </form>

                                        {activeSection == "activitySettings" ?

                                            <ActivitySettings type={settingsType} close={close} addActivity={addActivity} module_activity={activity} removeActivity={removeActivity} moduleId={activeModuleIndex} activityId={activeActivityIndex} />

                                            :

                                            activeSection == "activity" ?

                                                <ActivitySelection showActivitySettings={showActivitySettings} close={close} />

                                                :

                                                activeSection == "colors" ?

                                                    <Colors colors={project["COLORS"]} saveColor={saveColor} setPicker={setPicker} picker={picker} hideColors={hideColors} />

                                                    :

                                                    activeSection == "logo" ?

                                                        <Logo logo={project["logo"]} saveLogo={saveLogo} hideLogo={hideLogo} />

                                                        :

                                                        activeSection == "marketingAutomation" ?

                                                            <MarketingAutomation value={project["texts"]} saveMarketingAutomation={saveMarketingAutomation} hideMarketingAutomation={hideMarketingAutomation} />

                                                            :

                                                            activeSection == "rewards" ?

                                                                <Rewards value={project["rewards"]} saveRewards={saveRewards} hideRewards={hideRewards} />

                                                                :

                                                                activeSection == "moduleImage" ?

                                                                    <ModuleImage moduleIndex={moduleImageIndex} moduleImage={moduleImage} saveModuleImage={saveModuleImage} hideModuleImage={hideModuleImage} />

                                                                    :

                                                                    activeSection == "UITexts" ?

                                                                        <UITexts value={project["ui_texts"]} saveUITexts={saveUITexts} hideUITexts={hideUITexts} />

                                                                        :

                                                                        activeSection == "Avatars" ?

                                                                            <Avatars value={project["avatars"]} saveAvatars={saveAvatars} hideAvatars={hideAvatars} />

                                                                            :
                                                                            activeSection === "InAppNotifications" ?
                                                                                <InAppNotifications
                                                                                    value={project["inAppNotifications"]}
                                                                                    saveInAppNotifications={saveInAppNotifications}
                                                                                    hideInAppNotifications={hideInAppNotifications}
                                                                                />
                                                                                :

                                                                                <div className="right create_right">

                                                                                    <div className="gradient-title">
                                                                                        Create activities for your event
                                                                                    </div>

                                                                                </div>


                                        }

                                    </section>

                                    <div>
                                        <section className="section_activities">
                                            <h2>Preview</h2>

                                            {logo ?

                                                <div className="download-logo">
                                                    <img src={logo} alt="" />
                                                </div>

                                                :

                                                null
                                            }

                                            <Preview project={project} />

                                        </section>

                                        <div className="unpublish" onClick={handleSubmit(unpublishButton)}>Unpublish</div>
                                        <div className="error unpublish-error">{unpublishMessage}</div>
                                    </div>



                                </div>

                            </div>

                            :

                            null

                        }
                    </>

                    :

                    projects && user &&

                        <Premium setShowPremium={setShowPremium} title="Unlock to create new project" />

                }

            </main>

            <Footer />
            {
                showPremium &&
                    <Premium setShowPremium={setShowPremium} title="Unlock this activity" />
            }

        </div>
    )

}

